import React, { useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

const GET_ACCESS_GROUPS = gql`
  query accessGroups($first: Int!) {
    accessGroups(first: $first) {
      edges {
        id
        name
      }
    }
  }
`;

const GET_READERS = gql`
  query singleReaderAccessRights($first: Int!) {
    readers(first: $first) {
      engageReaders {
        id
        name
        type
      }
    }
  }
`;

const useStyles = makeStyles(() => ({
  grid: {
    flexGrow: 1,
    padding: '2%',
  },
  // TODO: 'formGroup2' is referenced but not defined
}));

const AccessGroupsMobile = ({ AGSDR, setAGSDR, AGData }) => {
  const classes = useStyles();
  const initialValuesAG = AGSDR ? [AGSDR] : false;
  const [text, setText] = useState('');
  const [agchecked, setAGChecked] = useState([]);
  const [sdrchecked, setSDRChecked] = useState([]);
  const [accessGroups, setAccessGroups] = useState([]);
  const [singleReaderAccessRights, setSingleReaderAccessRights] = useState([]);

  const handleAGChecked = (event) => {
    const present = agchecked.findIndex((items) => items === event);
    if (present < 0) {
      agchecked.push(event);
    } else {
      agchecked.splice(present, 1);
    }
  };

  const handleSDRChecked = (event) => {
    const present = sdrchecked.findIndex((items) => items === event);
    if (present < 0) {
      sdrchecked.push(event);
    } else {
      sdrchecked.splice(present, 1);
    }
  };

  const handleAGSearch = (event) => {
    setText(event.target.value);
  };

  const queryAGCompleted = (data) => {
    setAccessGroups(data.accessGroups.edges);
  };

  const queryReadersCompleted = (data) => {
    setSingleReaderAccessRights(data.readers.engageReaders);
  };

  const queryError = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
  };

  const { loading, error } = useQuery(GET_ACCESS_GROUPS, {
    variables: { first: 1000 },
    notifyOnNetworkStatusChange: true,
    onCompleted: queryAGCompleted,
    onError: queryError,
  });

  const { loading: loadingSingleReader, ERROR: errorSingleReader } = useQuery(GET_READERS, {
    variables: { first: 1000 },
    notifyOnNetworkStatusChange: true,
    onCompleted: queryReadersCompleted,
    onError: queryError,
  });

  const handleSaveAccess = () => {
    const accessValues = {
      accessGroups: agchecked,
      singleReaderAccessRights: { engageReaders: sdrchecked },
    };

    AGData(accessValues);
  };

  const generateRendering = () => {
    return (
      <>
        <div onClickCapture={handleSaveAccess}>
          <FormControl component="fieldset">
            <Typography variant="h6" style={{ padding: '10px' }} color="primary">
              Add Access Group
            </Typography>
            <div className={classes.grid}>
              <Grid container spacing={3} className={classes.formGroup2}>
                <Grid item xs="12">
                  <TextField
                    value={text}
                    style={{ width: '90vw' }}
                    onInput={handleAGSearch}
                    placeholder="Search for Access Group/Single Door Rights"
                    type="search"
                    variant="outlined"
                  />
                </Grid>

                {!loading &&
                  !error &&
                  (text
                    ? accessGroups
                        .filter((ag) => ag.name.includes(text))
                        .map((ag) => {
                          const { name } = ag;
                          return (
                            <>
                              <Grid item xs="6">
                                <FormLabel>{ag.name}</FormLabel>
                              </Grid>
                              <Grid
                                item
                                xs="6"
                                style={{ display: 'flex', justifyContent: 'flex-end' }}
                              >
                                <Switch
                                  checked={
                                    initialValuesAG[0].accessGroups
                                      ? initialValuesAG[0].accessGroups.some(
                                          (group) => group.name === ag.name
                                        )
                                      : false
                                  }
                                  onChange={() => {
                                    handleAGChecked(ag);
                                  }}
                                  name={name}
                                />
                              </Grid>
                            </>
                          );
                        })
                    : accessGroups.map((ag) => {
                        return (
                          <>
                            <Grid item xs="6">
                              <FormLabel>{ag.name}</FormLabel>
                            </Grid>
                            <Grid
                              item
                              xs="6"
                              style={{ display: 'flex', justifyContent: 'flex-end' }}
                            >
                              <Switch
                                checked={
                                  initialValuesAG[0].accessGroups
                                    ? initialValuesAG[0].accessGroups.some(
                                        (group) => group.name === ag.name
                                      )
                                    : false
                                }
                                onChange={() => {
                                  handleAGChecked(ag);
                                }}
                                name={ag.name}
                              />
                            </Grid>
                          </>
                        );
                      }))}
                {!loading &&
                  !error &&
                  (text
                    ? singleReaderAccessRights
                        .filter((sd) => sd.name.includes(text))
                        .map((sd) => {
                          return (
                            <>
                              <Grid item xs="6">
                                <FormLabel>{sd.name}</FormLabel>
                              </Grid>
                              <Grid
                                item
                                xs="6"
                                style={{ display: 'flex', justifyContent: 'flex-end' }}
                              >
                                <Switch
                                  checked={
                                    initialValuesAG[0].singleReaderAccessRights.engageReaders
                                      ? initialValuesAG[0].singleReaderAccessRights.engageReaders.some(
                                          (group) => group.name === sd.name
                                        )
                                      : false
                                  }
                                  onChange={() => {
                                    handleSDRChecked(sd);
                                  }}
                                />
                              </Grid>
                            </>
                          );
                        })
                    : singleReaderAccessRights.map((sd) => {
                        return (
                          <>
                            <Grid item xs="6">
                              <FormLabel>{sd.name}</FormLabel>
                            </Grid>
                            <Grid
                              item
                              xs="6"
                              style={{ display: 'flex', justifyContent: 'flex-end' }}
                            >
                              <Switch
                                checked={
                                  initialValuesAG[0].singleReaderAccessRights.engageReaders
                                    ? initialValuesAG[0].singleReaderAccessRights.engageReaders.some(
                                        (group) => group.name === sd.name
                                      )
                                    : false
                                }
                                onChange={() => {
                                  handleSDRChecked(sd);
                                }}
                              />
                            </Grid>
                          </>
                        );
                      }))}
              </Grid>
            </div>
          </FormControl>
        </div>
      </>
    );
  };

  return <>{generateRendering(AGSDR)}</>;
};

export default AccessGroupsMobile;
